import { Badge, Flex, IconButton, Text, Tooltip } from "@radix-ui/themes";
import { Copy, Check } from "lucide-react";
import { OwnedPersonalCode } from "@/types/breeze/AnythinkPay";
import { useCopyToClipboard } from "@/utils/clipboard";

type Props = {
  codes: OwnedPersonalCode[] | null | undefined;
  isLoading?: boolean;
};

export default function UserReferralCodeCell({ codes, isLoading }: Props) {
  const { copiedValue, copy } = useCopyToClipboard();

  if (isLoading) return <Text size="1" color="gray">Loading…</Text>;
  if (!codes || codes.length === 0) return <Text size="1" color="gray">—</Text>;

  return (
    <Flex direction="column" gap="1">
      {codes.map((c) => (
        <Flex key={c.offer_id} align="center" gap="1">
          <Tooltip content={c.offer_name ?? "Referral programme"}>
            <Badge size="1" variant="soft" color="indigo" style={{ fontFamily: "monospace" }}>
              {c.slug}
            </Badge>
          </Tooltip>
          <Tooltip content={copiedValue === c.slug ? "Copied" : "Copy code"}>
            <IconButton variant="ghost" size="1" onClick={() => copy(c.slug)}>
              {copiedValue === c.slug ? <Check size={12} /> : <Copy size={12} />}
            </IconButton>
          </Tooltip>
        </Flex>
      ))}
    </Flex>
  );
}
